import { useState } from 'react';
import { Link } from 'react-router-dom';

import '../style/Services.css';

const Services = () => {
  const [selectedService, setSelectedService] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const services = [
    'Admin',
    'Electrical',
    'Plumbing',
    'HVAC',
    'Carpentry',
    'Painting',
    'Others',
  ];

  const handleSearch = () => {
    console.log(
      `Searching for: ${searchQuery} in ${selectedService || 'All Services'}`
    );
  };

  return (
    <>
      <title>REM Services</title>
      <meta
        name='description'
        content='Access our services collection under Charese REM.'
      />

      <div className='services-container'>
        <h1>Find a Service</h1>

        <div className='contact-message'>
          For general service inquiries, please{' '}
          <Link to='/contact'>contact us</Link>!
        </div>

        <div className='services-search-box'>
          <div>
            <input
              type='text'
              className='services-search-input'
              placeholder='Search for services...'
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <div className='services-form-p2'>
            <select
              className='services-dropdown'
              value={selectedService}
              onChange={(e) => setSelectedService(e.target.value)}
            >
              <option value=''>All Services</option>
              {services.map((service) => (
                <option key={service} value={service}>
                  {service}
                </option>
              ))}
            </select>
            <button className='services-button' onClick={handleSearch}>
              Search
            </button>
          </div>
        </div>

        <div className='maintenance-message'>
          Our services database is being refereshed! Check back in February 2026
          {' :)'}
        </div>
      </div>
    </>
  );
};

export default Services;
